import { Box, Grid } from '@material-ui/core'
import { SpacingContainer } from '../../../../components/common/Containers/Base'
import Typography from '../../../../components/common/Typography'
import { useTrans } from '../../../../services/i18n'
import ListInfoRow from '../../../../components/generics/ListInfoRow'
import SortingPanel from '../../../../components/generics/SortingPanel'
import React from 'react'
import connect from '../connect'
import StatusDropdown from './StatusDropdown'
import OrganizationNameFilter from './OrganizationNameFilter'
import UpdatedAtFilter from './UpdatedAtFilter'

const Header = ({
  subcontractorForms,
  onChangeOrder,
  onChangeFilters,
  fetchList,
}) => {
  const { trans } = useTrans()
  const orderOptions = [
    {
      name: 'Submission date',
      value: 'createdAt',
      asc: 'Oldest first',
      desc: 'Newest first',
    },
    {
      name: 'Updated date',
      value: 'updatedAt',
      asc: 'Oldest first',
      desc: 'Newest first',
    },
  ]
  const { order, count } = subcontractorForms

  return (
    <>
      <SpacingContainer py={3} px={0}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography
              weight="600"
              variant="h2"
              fontFamily="lexend"
              title
              style={{ alignItems: 'center', display: 'flex' }}
            >
              {trans('teaming-opportunities')}
            </Typography>
          </Grid>
          <Grid item></Grid>
        </Grid>
      </SpacingContainer>

      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <ListInfoRow
              count={count}
              description={trans('results')}
              sort={
                <SortingPanel
                  order={order}
                  scope="SUBCONTRACTOR_FORMS"
                  orderOptions={orderOptions}
                  onChangeOrder={onChangeOrder}
                />
              }
            />
          </Box>
          <Box flexShrink={0}>
            <StatusDropdown />
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={2} spacing={2}>
          <Box flex="0 1 350px" mr={2}>
            <OrganizationNameFilter />
          </Box>
          <Box flexShrink={0}>
            <UpdatedAtFilter />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default connect(Header)
